import { useNavigate } from 'react-router-dom';
import { UploadZone } from '../components/upload/UploadZone';

export function UploadPage() {
  const navigate = useNavigate();

  const handleAllUploadsComplete = (contentIds: string[]) => {
    if (contentIds.length === 1) {
      // Single upload — go straight to that content's page
      navigate(`/content/${contentIds[0]}`);
    } else if (contentIds.length > 1) {
      // Multiple uploads — go to the library
      navigate('/library');
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Upload Content</h1>
        <p className="text-sm text-gray-500">
          Upload videos and images to start creating social media posts.
          Files upload directly to S3 — no size limits through the server.
        </p>
      </div>

      <UploadZone onAllUploadsComplete={handleAllUploadsComplete} />

      <div className="rounded-lg bg-brand-cream-50 p-4">
        <h3 className="text-sm font-semibold text-gray-700">How it works</h3>
        <ol className="mt-2 space-y-1 text-sm text-gray-600">
          <li>1. Drop or select your video/image files</li>
          <li>2. Add titles and descriptions</li>
          <li>3. Files upload directly to cloud storage</li>
          <li>4. AI will generate platform-specific drafts for your review</li>
          <li>5. Approve, edit, or reject drafts before publishing</li>
        </ol>
      </div>
    </div>
  );
}
